<template>
  <!-- v-if="this.$store.state.role.roleName === 'Super Admin'" -->
   <div v-if="$store.state.role.dashboard || checkMultipeActiveRoles(['vgos', 'mesta', 'jobseeker'])">
  <div v-if="this.roleCluster === 'All Clusters' && this.roleSchool === 'All'">
    <v-carousel
      v-model="activeIndex"
      :cycle="false"
      interval="60000"
      height="100vh"
      hide-delimiters
      :show-arrows="false"
      class="custom-carousel home-view-carousel v-window-item"
      
    >
      <v-carousel-item v-if="carouselViews.includes('managementDashboard')">
          <ManagementDashboard />
        </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('trendlineDashboard')">
          <TrendlineDashboard />
      </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('comparisonDashboard')">
          <ComparisonDashboard />
      </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('mixpanelDashboard')">
          <MixpanelDashboard />
      </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('volt')">
          <VoltDashboard />
      </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('mesta')">
        <MestaDashboard />
      </v-carousel-item>
    </v-carousel>

    <div class="carousel-buttons">
      <v-chip
        v-for="(view, i) in carouselViews"
        :key="i"
        class="carousel-button"
        :style="
          i !== activeIndex ? 'width: 16px !important ; height : 16px;' : ''
        "
        :class="{ active: i === activeIndex }"
        @click="activeIndex = i"
        :color="activeIndex === i ? 'blue' : 'blue-01 lighten-4'"
        fab
        small
        rounded
      >
      </v-chip>
    </div>
  </div>

  <!-- #################################################### -->
  <!-- school role  -->

  <div v-else-if="this.roleCluster !== 'All Clusters' && this.roleSchool !== 'All'">
   
    <v-carousel
      v-model="activeIndex"
      :cycle="false"
      interval="60000"
      height="100vh"
      hide-delimiters
      :show-arrows="false"
      class="custom-carousel home-view-carousel v-window-item"
      
    >
      <v-carousel-item v-if="carouselViews.includes('managementDashboard')">
        <ManagementDashboard />
      </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('trendlineDashboard')">
          <TrendlineDashboard />
      </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('comparisonDashboard')">
          <ComparisonDashboard />
      </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('mixpanelDashboard')">
          <MixpanelDashboard />
      </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('volt')">
          <VoltDashboard/>
      </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('mesta')">
          <MestaDashboard />
      </v-carousel-item>
    </v-carousel>

    <div class="carousel-buttons">
      <v-chip
        v-for="(view, i) in carouselViews"
        :key="i"
        class="carousel-button"
        :style="
          i !== activeIndex
            ? ' min-width: 16px; width: 16px !important ; height : 15px;'
            : ''
        "
        :class="{ active: i == activeIndex }"
        @click="activeIndex = i"
        :color="activeIndex == i ? 'blue' : 'blue-01 lighten-4'"
        fab
        small
        rounded
      >
      </v-chip>
    </div>
  </div>

  <!-- ################################# -->
  <!-- cluster role -->

  <div v-else-if="this.roleCluster !== 'All Clusters' && this.roleSchool === 'All'">
    <v-carousel
      v-model="activeIndex"
      :cycle="false"
      interval="60000"
      height="100vh"
      hide-delimiters
      :show-arrows="false"
      class="custom-carousel home-view-carousel v-window-item"
    >
      <v-carousel-item v-if="carouselViews.includes('managementDashboard')">
        <ManagementDashboard />
      </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('trendlineDashboard')">
        <TrendlineDashboard />
      </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('comparisonDashboard')">
        <ComparisonDashboard />
    </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('mixpanelDashboard')">
          <MixpanelDashboard />
      </v-carousel-item>
      
        <v-carousel-item v-if="carouselViews.includes('volt')">
          <VoltDashboard />
      </v-carousel-item>

      <v-carousel-item v-if="carouselViews.includes('mesta')">
         <MestaDashboard />
      </v-carousel-item>
    </v-carousel>

    <div class="carousel-buttons">
      <v-chip
        v-for="(view, i) in carouselViews"
        :key="i"
        class="carousel-button"
        :style="
          i !== activeIndex
            ? ' min-width: 16px ;width: 16px !important ; height : 15px;'
            : ''
        "
        :class="{ active: i === activeIndex }"
        @click="activeIndex = i"
        :color="activeIndex === i ? 'blue' : 'blue-01 lighten-4'"
        fab
        small
        rounded
      >
      </v-chip>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Notification from "./Notification";
import DonutChart from "./DonutChart.vue";
import DonutChartCluster from "./DonutChartCluster.vue";
import DonutChartSchool from "./DonutChartSchool.vue";
import DonutChartAdminJobSeeker from "./DonutChartAdminJobSeeker.vue";
// Common Funnel Chart Component
import FunnelChartCommon from "./FunnelChartCommon.vue";
import AuthService from "@/services/AuthService";
import { VCarousel, VCarouselItem, VTemplate } from "vuetify/lib";
import MestaDashboard from './MestaDashboard.vue';
import UserNavMenu from "@/components/UserNavMenu.vue";
import ManagementDashboard from './ManagementDashboard.vue';
import TrendlineDashboard from './TrendlineDashboard.vue'
import ComparisonDashboard from './ComparisonDashboard.vue'
import MixpanelDashboard from './MixpanelDashboard.vue';
import VoltDashboard from './VoltDashboard.vue';
import {
  collection,
  getDocs,
  onSnapshot,
  doc,
  collectionGroup,
  query,
  where,
  QuerySnapshot,
  getCountFromServer,
  getDoc,
  orderBy
} from "firebase/firestore";
import { db } from "../firebase";
import { onUnmounted } from "vue";
import { mapState } from "vuex";
import { liveListenerUnsubscriber } from "../mixins/liveListenerUnsubcriber";
import {roleInfoMixin} from "@/mixins/roleInfoMixin";

export default {
  name: "HomeView",
  mixins: [liveListenerUnsubscriber, roleInfoMixin],
  components: {
    Notification,
    DonutChart,
    DonutChartCluster,
    DonutChartSchool,
    DonutChartAdminJobSeeker,
    FunnelChartCommon,
    MestaDashboard,
    UserNavMenu,
    ManagementDashboard,
    TrendlineDashboard,
    ComparisonDashboard,
    MixpanelDashboard,
    VoltDashboard
  },
  data() {
    return {
      passedTeachers:[
      {
        text:"No of Teachers 10",
        value:10
      },
      {
        text:"No of Teachers 20",
        value:20
      },
      {
        text:"No of Teachers 50",
        value:50
      },
      {
        text:"No of Teachers 100",
        value:100
      },
      {
        text:"No of Teachers 300",
        value:300
      }
      ],
      notificationDialog: false,
      fullscreenBackgroundColor: "green",
      topSchools: [],
      topTeachers: [],
      teachers: [],
      roleName: "",

      schools: [],
      donutArray: [],
      schoolTeacher: [],
      topTeacherInSchool: [],
      topJobSeekerInSchool: [],
      schoolJobSeeker: [],
      topJobSeekerInCluster: [],
      schoolClusterJobSeeker: [],
      schoolClusterTeacher: [],
      schoolClusterIntoTeacher: [],
      topTeacherInCluster: [],
      topTeacherIntoCluster: [],
      jobseekerArray: [],
      adminJobSeeker: [],
      topJobSeekerInAdmin: [],
      roles: "Admin",
      dashboardId: "management-dashbaord-001",
      teachersInTotalCampaign: 0,
      jobSeekerInTotalCampaign: 0,
      activeIndex: 0,
      activeIndex2: 0,
      totalSchools: 0,
      totalSchoolsCount: 0,
      countJobSeekerAtCluster: 0,
      countTeacherCluster: 0,
      totalTeachersCount: 0,
      countingTeacher: 0,
      countingDocumentCluster: 0,
      countingDocumentSchool: 0,
      countingJobSeeker: 0,
      countingJobSeekerCluster: 0,
      countingJobSeekerSchool: 0,
      liveCampaignlength: 0,
      totalPrePrimaryTeacher: 0,
      totalPrimaryTeacher: 0,
      totalSecondaryTeacher: 0,
      totalSeniorSecondaryTeacher: 0,
      totalMiddleTeacher: 0,
      totalTeachersParticipated: 0,
      scheduledCampaignlength: 0,
      expiredCampaignlength: 0,
      totalLiveTeacherCampaigns: 0,
      expiredCampaignCount: 0,
      liveCampaignCount: 0,
      upcomingCampaignCount: 0,
      expiredCampaignCountJB: 0,
      upcomingCampaignCountJB: 0,
      liveCampaignCountJB: 0,
      totalUsersParticipated: 0,
      totalTeachersParticipatedCount: 0,
      hover: "",
      clusterName: "",
      clusterData: [["", ""]],
      schoolData: [["", ""]],
      clustersData: [["", ""]],
      clusterLeveldata: [["", ""]],
      jobSeekerData: [["", ""]],
      schoolsData: [],
      mainsBookingTeacherSchool: new Map(),
      mainsBookingJobSeekerSchool: new Map(),
      jobSeekersClusterData: [],
      teacherCountClusterData: [],
      dropdownItems: [5],
      selectedItem: 5,
      tableRows: [],
      liveCampaign: [],
      scheduledCampaign: [],
      expiredCampaign: [],
      data: [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
        },
        {
          name: "Eclair",
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
        },
        {
          name: "Cupcake",
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
        },

        {
          name: "Honeycomb",
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
        },
      ],
      clusters: [],
      invited: 0,
      screeningStarted: 0,
      screeningPassed: 0,
      screeningFailed: 0,
      mainsStarted: 0,
      mainsPassed: 0,
      mainsFailed: 0,
      apraisals: 0,
      pip: 0,
      tbd: 0,
      chartData: {},
      emptyChartData: {
        invited: 0,
        screeningStarted: 0,
        screeningPassed: 0,
        screeningFailed: 0,
        mainsStarted: 0,
        mainsPassed: 0,
        mainsFailed: 0,
      },
      jobSeekerChartData: {},
      emptyJobSeekerChartData: {
        jobSeekerInvited: 0,
        jobSeekerScreeningStarted: 0,
        jobSeekerScreeningPassed: 0,
        jobSeekerScreeningFailed: 0,
        jobSeekerMainsStarted: 0,
        jobSeekerMainsPassed: 0,
        jobSeekerMainsFailed: 0,
      },
      recommended: 0,
      jobSeekerRejected: 0,
      jobSeekerTBD: 0,
      schoolChartData: {},
      emptySchoolChartData: {
        totalInvited: 0,
        totalScreeningStarted: 0,
        totalScreeningPassed: 0,
        totalScreeningFailed: 0,
        totalMainsStarted: 0,
        totalMainsPassed: 0,
        totalMainsFailed: 0,
      },
      schooolTeacherAppraisal: 0,
      schooolTeacherPip: 0,
      schooolTeacherTBD: 0,
      schoolJobSeekerChartData: {},
      emptySchoolJobSeekerChartData: {
        invited: 0,
        screeningStarted: 0,
        screeningPassed: 0,
        screeningFailed: 0,
        mainsStarted: 0,
        mainsPassed: 0,
        mainsFailed: 0,
        demoSubmitted: 0,
        interviewSubmitted: 0
      },
      clusterTeacherChartData: {},
      emptyClusterTeacherChartData: {
        totalInvited: 0,
        totalScreeningStarted: 0,
        totalScreeningPassed: 0,
        totalScreeningFailed: 0,
        totalMainsStarted: 0,
        totalMainsPassed: 0,
        totalMainsFailed: 0,
      },
      clusterJobSeekersChartData: {},
      emptyClusterJobSeekersChartData: {
        totalJobSeekersInvited: 0,
        totalJobSeekersScreeningStarted: 0,
        totalJobSeekersScreeningPassed: 0,
        totalJobSeekersScreeningFailed: 0,
        totalJobSeekersMainsStarted: 0,
        totalJobSeekersMainsPassed: 0,
        totalJobSeekersMainsFailed: 0,
        totalJobSeekersDemoSubmitted: 0,
        totalJobSeekersInterviewSubmitted: 0,
      },
      roleCluster: "",
      roleSchool: "",
      isFullScreen: false,

      funnelTeachersData: {
        invited: 0,
        screeningStarted: 0,
        screeningPassed: 0,
        screeningFailed: 0,
        mainsStarted: 0,
        mainsPassed: 0,
        mainsFailed: 0,
        demoSubmitted: 0,
        interviewSubmitted: 0,
      },
      funnelJobSeekersData: {
        invited: 0,
        screeningStarted: 0,
        screeningPassed: 0,
        screeningFailed: 0,
        mainsStarted: 0,
        mainsPassed: 0,
        mainsFailed: 0,
        demoSubmitted: 0,
        interviewSubmitted: 0
      },
      donutArrayAdminJobSeeker: [0, 0, 0],
      showComingSoon: false,
      recommendedJobseekerCount : 0
    };
  },
  computed: {
    ...mapGetters({
      userRole: 'getRoleFromStore', 
      userRoleId: 'getRoleId'
    }),
    displayedTeachers() {
      return this.topTeacherInSchool.slice(0, this.selectedItem);
    },
    displayedJobSeekers() {
      return this.topJobSeekerInSchool.slice(0, this.selectedItem);
    },
    displayedClusterJobSeekers() {
      return this.topJobSeekerInCluster.slice(0, this.selectedItem);
    },
    displayedClusterTeachers() {
      return this.topTeacherInCluster.slice(0, this.selectedItem);
    },
    displayedAdminJobSeeker() {
      return this.topJobSeekerInAdmin.slice(0, this.selectedItem);
    },
    bookingMainsTeacher() {
      return this.mainsBookingTeacherSchool;
    },
    bookingMainsJobSeeker() {
      return this.mainsBookingJobSeekerSchool;
    },
    carouselViews() {
      const role = this.$store.state?.role ?? {};

      return [
        role.managementDashboard?.read && 'managementDashboard',
        role.trendlineDashboard?.read && 'trendlineDashboard',
        role.comparisonDashboard?.read && 'comparisonDashboard',
        role.mixpanelDashboard?.read && 'mixpanelDashboard',
        role.vgos?.read && 'volt',
        role.mesta?.read && 'mesta',
      ].filter(Boolean);
    },
  },
  methods: {
    getFinalResult(data) {
      const {href}  = this.$router.resolve({
        path: "/userreport",
        name: "UserReport", //use name for router push
        query: {
          campaignId: data.campaignId,
          userId: data.userId,
        },
      });
      window.open(href, '_blank')
    },
    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },

    // toggleScreen() {
    //   // const elem = this.$refs.fullScreenElement;
    //   if (this.isFullScreen) {
    //     // If the document is already in full-screen mode, exit it.
    //     if (document.exitFullscreen) {
    //       document.exitFullscreen();
    //     } else if (document.mozCancelFullScreen) {
    //       document.mozCancelFullScreen();
    //     } else if (document.webkitExitFullscreen) {
    //       document.webkitExitFullscreen();
    //     } else if (document.msExitFullscreen) {
    //       document.msExitFullscreen();
    //     }
    //     this.isFullScreen = !this.isFullScreen;
    //   } else {
    //     if (document.documentElement.requestFullscreen) {
    //       document.documentElement.requestFullscreen();
    //     } else if (document.documentElement.mozRequestFullScreen) {
    //       document.documentElement.mozRequestFullScreen();
    //     } else if (document.documentElement.webkitRequestFullscreen) {
    //       document.documentElement.webkitRequestFullscreen();
    //     } else if (document.documentElement.msRequestFullscreen) {
    //       document.documentElement.msRequestFullscreen();
    //     }
    //     this.isFullScreen = !this.isFullScreen;
    //   }
    //   this.$store.state.isNavBar = this.isFullScreen;
    // },

    extractClusterNumber(cluster) {
      const clusterNumber = cluster.split(" ")[1];
      return clusterNumber;
    },

    async newTeacherFunnelChartDataListener() {
      const dashboardTeachersRef = doc(
        db,
        "dashboards",
        this.userRoleId + "-vgos-teachers-dashboard",
        "results",
        "campaignresults"
      );

      let unsubscribe = onSnapshot(dashboardTeachersRef, (doc) => {
        const resultData = doc.data();
        if (resultData) {
          this.funnelTeachersData = {
            invited: resultData.invited ? resultData.invited : 0,
            screeningStarted: resultData.screeningStarted
              ? resultData.screeningStarted
              : 0,
            screeningPassed: resultData.screeningPassed
              ? resultData.screeningPassed
              : 0,
            screeningFailed: resultData.screeningFailed
              ? resultData.screeningFailed
              : 0,
            mainsStarted: resultData.mainsStarted ? resultData.mainsStarted : 0,
            mainsPassed: resultData.mainsPassed ? resultData.mainsPassed : 0,
            mainsFailed: resultData.mainsFailed ? resultData.mainsFailed : 0,
            demoSubmitted: resultData.demoSubmitted ? resultData.demoSubmitted : 0,
            interviewSubmitted: resultData.interviewSubmitted ? resultData.interviewSubmitted : 0,
          };
        }
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async newJobSeekerFunnelChartDataListener() {
      console.log('this.userRoleId + "-jobseekers-dashboard"', this.userRoleId + "-jobseekers-dashboard")
      const dashboardJobSeekersRef = doc(
        db,
        "dashboards",
        this.userRoleId + "-jobseekers-dashboard",
        "results",
        "campaignresults"
      );

      // const dashboardJobSeekersRef=doc(db, "dashboards", "12345-jobseekers-dashboard", "results", "campaignresults")

      let unsubscribe = onSnapshot(dashboardJobSeekersRef, (doc) => {
        const resultData = doc.data();
        if (resultData) {
          this.funnelJobSeekersData = {
            invited: resultData.invited ? resultData.invited : 0,
            screeningStarted: resultData.screeningStarted
              ? resultData.screeningStarted
              : 0,
            screeningPassed: resultData.screeningPassed
              ? resultData.screeningPassed
              : 0,
            screeningFailed: resultData.screeningFailed
              ? resultData.screeningFailed
              : 0,
            mainsStarted: resultData.mainsStarted ? resultData.mainsStarted : 0,
            mainsPassed: resultData.mainsPassed ? resultData.mainsPassed : 0,
            mainsFailed: resultData.mainsFailed ? resultData.mainsFailed : 0,
            demoSubmitted: resultData.demoSubmitted ? resultData.demoSubmitted : 0,
            interviewSubmitted: resultData.interviewSubmitted ? resultData.interviewSubmitted : 0            
          };
        }
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async setupSnapshotListener() {
      const dashboardRef = doc(db, "dashboards", "management-dashboard-001");

      let unsubscribe = onSnapshot(dashboardRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          const totalClusters = data.totalClusters;
        } else {
          // console.log("Document does not exist");
        }
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },
    async extractClusterData() {
      try {
        // console.log("inside extractClusterData fun >>>>........");
        const clustersRef = collection(
          db,
          "dashboards",
          "management-dashboard-001",
          "clusters"
        );
        // console.log("cluster ref", clustersRef);
        // const clustersSnapshot = await getDocs(clustersRef);

        let unsubscribe = onSnapshot(clustersRef, (clustersSnapshot) => {
          this.clusterData = [["", ""]];
          clustersSnapshot.forEach((clusterDoc) => {
            const { name, totalTeachersInCluster } = clusterDoc.data();
            let noOfTeachers = parseInt(totalTeachersInCluster);
            this.clusterval = [name, noOfTeachers];
            this.clusterData.push(this.clusterval);
          });
        });
        this.liveListenersToUnsubscribeMixin.push(unsubscribe);
      } catch (error) {
        // console.error("Error extracting cluster data:", error);
      }
    },

    // donut chart Admin for TEACHERS .....
    // async extractClusterData() {
    //   try {
    //     //console.log("inside extractClusterData fun >>>>........");
    //     const clustersRef = collection(
    //       db,
    //       "dashboards",
    //       this.userRoleId + "-vgos-teachers-dashboard",
    //       //  "123456-vgos-teachers-dashboard",
    //       "clusters"
    //     );
    //     // console.log("cluster ref", clustersRef);
    //     // const clustersSnapshot = await getDocs(clustersRef);

    //     onSnapshot(clustersRef, (clustersSnapshot) => {
    //       this.clusterData = [["", ""]];

    //       clustersSnapshot.forEach((clusterDoc) => {
    //         //console.log("clustersName >>>>,,,,,,,", clusterDoc.data());
    //         const clusterData = clusterDoc.data();
    //         const clusterCountValue = clusterData.clusterCount;
    //         //const { name, totalSchools } = clusterDoc.data();
    //         this.clusterval = [clusterDoc.id, clusterCountValue];
    //         this.clusterData.push(this.clusterval);
    //       });
    //     });
    //   } catch (error) {
    //     // console.error("Error extracting cluster data:", error);
    //   }
    // },

    async setupschoolSnapshotListener() {
      const schoolName = this.$store.state.role.schools;
      // console.log("schoolName >>", schoolName);
      const q = query(
        collection(db, "dashboards", "management-dashboard-001", "schools"),
        where("name", "==", schoolName)
      );

      let unsubscribe = onSnapshot(q, (querySnapshot) => {
        this.schoolData = [["", ""]];
        const posts = [
          "Foundational",
          "Preparatory",
          "Middle",
          "Secondary",
          "Senior Secondary",
        ];
        querySnapshot.forEach((d) => {
          console.log("querySnapshotData", d.data());
          for (const post of posts) {
            this.schoolData.push([post, d.data()[post]]);
            console.log("queryabcdefghi", d.data()[post]);
          }
        });
        // console.log("schoolData >>", this.schoolData);
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async setupAdminJobSeekerSnapshot() {
      const clusterManagementRef = collection(db, "dashboards", "management-dashboard-001","clusters");
      let unsubscribe1 = onSnapshot(clusterManagementRef, (snapshot) => {
        this.jobSeekerData.splice(1);
        snapshot.forEach((doc) => {
          const data = doc.data();
          if (data) {
            const clusterCount = data.totalUsersInCluster;
            const clusterName = data.name;
            
            //console.log("Printing totalUsersParticipated",totalUsersParticipated);
              this.jobSeekerData.push([clusterName,clusterCount]);
            }
          })
        })
        const managementDoc = doc(db, "dashboards",  "management-dashboard-001")
        let unsubscribe2 = onSnapshot(managementDoc,(doc) => {
          const data = doc.data();
          if (data) {
            this.totalUsersParticipated = data.totalUsersParticipated;
          }
        })
        this.liveListenersToUnsubscribeMixin.push(...[unsubscribe1, unsubscribe2]);
    },

    async setupclusterTeacherCountSnapshot() {
      const clusterName = this.$store.state.role.clusterName;
      this.clusterName = clusterName;
      // console.log("ClusterrNameJobSeeker >>", clusterName);
      // const q = collection(db, "dashboards", "ums-dashboard", "schools");
      const roleId = this.userRoleId;
      const dashboardTeacherRef = collection(
        db,
        "dashboards",
        roleId + "-vgos-teachers-dashboard",
        "schools"
      );

      let unsubscribe = onSnapshot(dashboardTeacherRef, (schoolSnapshot) => {
        this.teacherCountClusterData.splice(0);
        schoolSnapshot.forEach(async (school) => {
          const schoolData = school.data();
          this.teacherCountClusterData.push({
            name: school.id,
            teachers: schoolData.totalTeachers,
          });
        });
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async setupclusterJobSeekerSnapshot() {
      const clusterName = this.$store.state.role.clusterName;
      this.clusterName = clusterName;

      const roleId = this.userRoleId;
      const dashboardJobSeekersRef = collection(
        db,
        "dashboards",
        roleId + "-jobseekers-dashboard",
        "schools"
      );

      let unsubscribe = onSnapshot(dashboardJobSeekersRef, (schoolSnapshot) => {
        this.jobSeekersClusterData.splice(0);
        schoolSnapshot.forEach((school) => {
          const schoolData = school.data();
          this.jobSeekersClusterData.push({
            name: school.id,
            jobSeekers: schoolData.totalJobSeekers,
          });
        });
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    getLevels(levelsRef){
      try{
        const levelsData = [];
        return new Promise((res)=>{
          let unsubscribe = onSnapshot(levelsRef, (snapshot)=>{
          snapshot.docs.forEach((doc) => {
          levelsData.push(doc.data());
          })
          res(levelsData)
        })
        this.liveListenersToUnsubscribeMixin.push(unsubscribe);
      })
    }
      catch(error){
        console.log(error)
      }      
    },

    getLvlCountData(dashboardRef){
      try{
        return new Promise((res)=>{
          let unsubscribe = onSnapshot(dashboardRef, (lvlCount) => {
          this.clusterLeveldata.splice(1);
          res(lvlCount.data());
          })
          this.liveListenersToUnsubscribeMixin.push(unsubscribe);
        })
      }
      catch(error){
        console.log(error)
      }
    },

    checkLevelDataValue(levelData,level){
      return typeof levelData[level]=='undefined'? 0 : levelData[level]
    },

    async setupclusterSnapshotListener() {
      const clusterName = this.$store.state.role.clusterName;
      this.clusterName = clusterName;
      const roleId = this.userRoleId;
      console.log("user_details", this.$store.state.role);
      // const q = doc(db, "dashboards", "ums-dashboard", "clusters", clusterName);
      const dashboardRef = doc(
        db,
        "dashboards",
        roleId + "-vgos-teachers-dashboard",
        "clusterstrengths",
        "levelcount"
      );
      const levelsRef = collection(db,"levels");
      const levelsData = await this.getLevels(levelsRef);

      let allLevels = levelsData.map(level=>level.name)
      const levelData = await this.getLvlCountData(dashboardRef) 
      allLevels.forEach(level=>{
          this.clusterLeveldata.push([level, this.checkLevelDataValue(levelData,level)])
      })
    },

    async schoolCountListener() {
      const dashboardRef = collection(db, "users");
      // console.log("called");

      let unsubscribe = onSnapshot(dashboardRef, (snapshot) => {
        let countTeacher = 0;
        //console.log("datamdnwbdfwbfj", snapshot);
        // const schools = [];
        snapshot.docs.forEach((doc) => {
          const userData = doc.data();
          if (
            userData.userType?.toLowerCase() === "teacher" &&
            userData.campaignStatus !== undefined &&
            userData.campaignStatus.length === 1
          ) {
            // for Admin
            countTeacher++;
          }
        });
        this.countingTeacher = countTeacher;
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async schoolCountClusterListener() {
      const dashboardRef = collection(db, "users");
      // console.log("called");

      let unsubscribe = onSnapshot(dashboardRef, (snapshot) => {
        let countDocumentCluster = 0;
        //console.log("datamdnwbdfwbfj", snapshot);
        // const schools = [];
        snapshot.docs.forEach((doc) => {
          const userData = doc.data();
          if (
            userData.userType?.toLowerCase() === "teacher" &&
            userData.campaignStatus !== undefined &&
            userData.campaignStatus.length === 1 &&
            userData.cluster === this.$store.state.role.clusterName
          ) {
            countDocumentCluster++;
          }
        });
        this.countingDocumentCluster = countDocumentCluster;
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async schoolCountSchoolListener() {
      const dashboardRef = collection(db, "users");
      console.log("this.$store.state.role.schools",this.$store.state.role.schools);

      let unsubscribe = onSnapshot(dashboardRef, (snapshot) => {
        let countDocumentSchool = 0;
        //console.log("datamdnwbdfwbfj", snapshot);
        // const schools = [];
        snapshot.docs.forEach((doc) => {
          const userData = doc.data();
          if (
            userData.userType?.toLowerCase() === "teacher" &&
            userData.campaignStatus !== undefined &&
            userData.campaignStatus.length === 1 
            &&
            (userData?.schoolName == this.$store.state.role.schools || userData.schoolName?.includes(this.$store.state.role.schools))
          ) {
            console.log(userData.userId);
            countDocumentSchool++;
          }
          console.log("out");

        });
        this.countingDocumentSchool = countDocumentSchool;
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async jobSeekerCountListener() {
      const dashboardRef = collection(db, "users");
      // console.log("called");

      let unsubscribe = onSnapshot(dashboardRef, (snapshot) => {
        let countJobSeeker = 0;
        //console.log("datamdnwbdfwbfj", snapshot);
        // const schools = [];
        snapshot.docs.forEach((doc) => {
          const userData = doc.data();
          // console.log("userData--->>>>", userData, userData.size);
          if (
            userData.userType?.toLowerCase() === "job seeker" &&
            userData.campaignStatus !== undefined &&
            userData.campaignStatus.length === 1
          ) {
            // For Admin Job Seeker
            countJobSeeker++;
          }
        });
        this.countingJobSeeker = countJobSeeker;
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async jobSeekerCountClusterListener() {
      const dashboardRef = collection(db, "users");
      // console.log("called");

      let unsubscribe = onSnapshot(dashboardRef, (snapshot) => {
        let countJobSeekerCluster = 0;
        //console.log("datamdnwbdfwbfj", snapshot);
        // const schools = [];
        snapshot.docs.forEach((doc) => {
          const userData = doc.data();
          if (
            userData.userType?.toLowerCase() === "job seeker" &&
            userData.campaignStatus !== undefined &&
            userData.campaignStatus.length === 1 &&
            userData.cluster === this.$store.state.role.clusterName
          ) {
            // For Admin Job Seeker
            countJobSeekerCluster++;
          }
        });
        //this.countingJobSeekerCluster = countJobSeekerCluster;
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async jobSeekerCountSchoolListener() {
      const dashboardRef = collection(db, "users");
      // console.log("called");

      let unsubscribe = onSnapshot(dashboardRef, (snapshot) => {
        let countJobSeekerSchool = 0;
        //console.log("datamdnwbdfwbfj", snapshot);
        // const schools = [];
        snapshot.docs.forEach((doc) => {
          const userData = doc.data();
          if (
            userData.userType?.toLowerCase() === "job seeker" &&
            userData.campaignStatus !== undefined &&
            userData.campaignStatus.length === 1 &&
            userData.schoolName == this.$store.state.role.schools
          ) {
            // For Admin Job Seeker
            countJobSeekerSchool++;
          }
        });
        this.countingJobSeekerSchool = countJobSeekerSchool;
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async schoolSnapshotListener() {
      const dashboardRef = collection(
        db,
        "dashboards",
        "management-dashboard-001",
        "schools"
      );
      // console.log("called");

      let unsubscribe = onSnapshot(dashboardRef, (snapshot) => {
        //console.log("datamdnwbdfwbfj", snapshot);
        // const schools = [];
        this.schools.splice(0);
        snapshot.docs.forEach((doc) => {
          const schoolData = {
            cluster: doc.data().cluster == null ? "" : doc.data().cluster,
            rank: doc.data().rank == null ? 0 : doc.data().rank,
            name: doc.data().name == null ? "" : doc.data().name,
            totalMainsPassed: doc.data()?.totalMainsPassed
              ? doc.data().totalMainsPassed
              : 0,
            // totalScreeningStarted: doc.data()?.totalScreeningStarted
            //   ? doc.data().totalScreeningStarted
            //   : 0,
            
            totalMainsStarted: doc.data()?.totalMainsStarted ? doc.data().totalMainsStarted : 0,            
          };
          this.schools.push(schoolData);
          // if (schoolData.totalScreeningStarted > 0) {
          // }
        });
        this.schools.sort((p1, p2) =>
          p1.rank < p2.rank ? 1 : p1.rank > p2.rank ? -1 : 0
        );
        // console.log("this_schools :", this.schools)
        // schools.sort((a, b) => a.rank - b.rank);
        this.topSchools = this.schools.slice(0, this.selectedItem);
        // console.log("arrayOfSchool", this.topSchools);
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async jobSeekerAdminSnapshot() {
      const jobSeekersRef = collection(
        db,
        "dashboards",
        "management-dashboard-001",
        "jobseekers"
      );
      let unsubscribe = onSnapshot(jobSeekersRef, (snapshot) => {
        this.adminJobSeeker.splice(0);
        snapshot.docs.forEach(async (doc) => {
          const data = doc.data();
          const topJobSeekersClusterData = {
            userId : data.userId == undefined ? "" : data.userId ,
            campaignId : data.campaignId == undefined ? "" : data.campaignId,
            mainsTotal:
              data.mainsTotal == null ? "" : data.mainsTotal,
            name: data.name === null ? "" : data.name,
            // firstName:
            //   data.personalInfo.firstName == null
            //     ? ""
            //     : d.data().personalInfo.firstName,
            // lastName:
            //   d.data().personalInfo.lastName == null
            //     ? ""
            //     : d.data().personalInfo.lastName,
            // level: level,
            level: data.levels === null ? [] : data.levels,
          };
          this.adminJobSeeker.push(topJobSeekersClusterData);
        });
        let sortedProducts = this.adminJobSeeker.sort((p1, p2) =>
          p1.mainsTotal < p2.mainsTotal
            ? 1
            : p1.mainsTotal > p2.mainsTotal
            ? -1
            : 0
      );
      this.topJobSeekerInAdmin = this.adminJobSeeker;
    });
    this.liveListenersToUnsubscribeMixin.push(unsubscribe);

      // const campaignRef = collection(db, "campaigns"); // const schoolMarks = {}

      // onSnapshot(campaignRef, (snapshot) => {
      //   snapshot.docs.forEach(async (doc) => {
      //     // if teacher, run this

      //     if (doc.data().audienceType.toLowerCase() === "job_seeker") {
      //       try {
      //         const jobSeekerRef = collection(campaignRef, doc.id, "audience");
      //         const jobSeekDocs = await getDocs(jobSeekerRef);

      //         jobSeekDocs.forEach((d) => {
      //           const level = [];
      //           if (d.data().responsibleTeachingAt) {
      //             for (const l of d.data().responsibleTeachingAt) {
      //               level.push(l.level);
      //             }
      //           }
      //           //console.log("screening total >>", d.data().screeningTotal);
      //           const topJobSeekersClusterData = {
      //             screeningTotal:
      //               d.data().screeningTotal == null
      //                 ? ""
      //                 : d.data().screeningTotal,
      //             firstName:
      //               d.data().personalInfo.firstName == null
      //                 ? ""
      //                 : d.data().personalInfo.firstName,
      //             lastName:
      //               d.data().personalInfo.lastName == null
      //                 ? ""
      //                 : d.data().personalInfo.lastName,
      //             cluster: d.data().cluster == null ? "" : d.data().cluster,
      //             level: level,
      //           };

      //           // console.log("hotttt chocolate>>>", topJobSeekersClusterData);
      //           this.adminJobSeeker.push(topJobSeekersClusterData);
      //           console.log(
      //             "screening total result show >>",
      //             d.data().screeningTotal
      //           );
      //           // data.schoolMarks[d.data().schoolName] += d.data().screeningTotal
      //         });

      //         let sortedProducts = this.adminJobSeeker.sort((p1, p2) =>
      //           p1.screeningTotal < p2.screeningTotal
      //             ? 1
      //             : p1.screeningTotal > p2.screeningTotal
      //               ? -1
      //               : 0
      //         );
      //         this.topJobSeekerInAdmin = this.adminJobSeeker;
      //         console.log("Final data >>>>", this.topJobSeekerInAdmin);
      //       } catch (error) {
      //         console.error("Error fetching audience collection:", error);
      //       }
      //     }
      //   });
      // });
    },

    // COMMENTED CODE FOR SCHOOL LEVEL EARLIER
    // async teacherSnapshotListener() {
    //   const campaignRef = collection(db, "campaigns"); // const schoolMarks = {}

    //   onSnapshot(campaignRef, (snapshot) => {
    //     snapshot.docs.forEach(async (doc) => {
    //       // if teacher, run this
    //       // console.log("doc id >>", doc.id)
    //       if (doc.data().audienceType.toLowerCase() === "job_seeker") {
    //         console.log("teacher >>", doc.id);
    //         try {
    //           const jobSeekerRef = collection(campaignRef, doc.id, "audience");
    //           const jobSeekDocs = await getDocs(jobSeekerRef);

    //           jobSeekDocs.forEach((d) => {
    //             //console.log("screening total >>", d.data().screeningTotal);
    //             if (d.data().schoolName == this.$store.state.role.schools) {
    //               const level = [];
    //               if (d.data().responsibleTeachingAt) {
    //                 for (const l of d.data().responsibleTeachingAt) {
    //                   level.push(l.level);
    //                 }
    //               }
    //               const topJobSeekersData = {
    //                 screeningTotal:
    //                   d.data().screeningTotal == null
    //                     ? ""
    //                     : d.data().screeningTotal,
    //                 firstName:
    //                   d.data().personalInfo.firstName == null
    //                     ? ""
    //                     : d.data().personalInfo.firstName,
    //                 lastName:
    //                   d.data().personalInfo.lastName == null
    //                     ? ""
    //                     : d.data().personalInfo.lastName,
    //                 cluster: d.data().cluster == null ? "" : d.data().cluster,
    //                 // level: d.data().levels == null ? [] : d.data().levels,
    //                 level: level,
    //                 //user.data().personalInfo.firstName
    //               };
    //               this.schoolJobSeeker.push(topJobSeekersData);
    //               // console.log(
    //               //   "screening total result show >>",
    //               //   d.data().screeningTotal
    //               // );
    //               // console.log("naresh sir", this.schoolJobSeeker);
    //             } // data.schoolMarks[d.data().schoolName] += d.data().screeningTotal
    //           });
    //           let sortedProducts = this.schoolJobSeeker.sort((p1, p2) =>
    //             p1.screeningTotal < p2.screeningTotal
    //               ? 1
    //               : p1.screeningTotal > p2.screeningTotal
    //               ? -1
    //               : 0
    //           );
    //           this.topJobSeekerInSchool = this.schoolJobSeeker;
    //         } catch (error) {
    //           console.error("Error fetching audience collection:", error);
    //         }
    //       } // if jobseeker, run this
    //       else {
    //         // for (const sName of doc.data().schools) {
    //         //   if (!(sName in data.schoolMarks)) {
    //         //     console.log("entered");
    //         //     data.schoolMarks[sName] = 0;
    //         //   }
    //         // }
    //         try {
    //           const jobSeekerRef = collection(campaignRef, doc.id, "audience");
    //           const jobSeekDocs = await getDocs(jobSeekerRef);

    //           jobSeekDocs.forEach((d) => {
    //             //console.log("screening total >>", d.data().screeningTotal);
    //             if (d.data().schoolName == this.$store.state.role.schools) {
    //               const topTeachersData = {
    //                 screeningTotal:
    //                   d.data().screeningTotal == null
    //                     ? ""
    //                     : d.data().screeningTotal,
    //                 firstName:
    //                   d.data().personalInfo.firstName == null
    //                     ? ""
    //                     : d.data().personalInfo.firstName,
    //                 lastName:
    //                   d.data().personalInfo.lastName == null
    //                     ? ""
    //                     : d.data().personalInfo.lastName,
    //                 cluster: d.data().cluster == null ? "" : d.data().cluster,
    //                 //user.data().personalInfo.firstName
    //               };
    //               this.schoolTeacher.push(topTeachersData);
    //               // console.log(
    //               //   "screening total result show >>",
    //               //   d.data().screeningTotal
    //               // );
    //               //console.log("naresh sir", this.schoolTeacher);
    //             } // data.schoolMarks[d.data().schoolName] += d.data().screeningTotal
    //           });
    //           let sortedProducts = this.schoolTeacher.sort((p1, p2) =>
    //             p1.screeningTotal < p2.screeningTotal
    //               ? 1
    //               : p1.screeningTotal > p2.screeningTotal
    //               ? -1
    //               : 0
    //           );
    //           this.topTeacherInSchool = this.schoolTeacher;
    //         } catch (error) {
    //           console.error("Error fetching audience collection:", error);
    //         }
    //         // console.log("job seeker id >>", doc.id) // go to audience collection. // const docRef=doc(campaignRef, doc.id, ) // fetch screeningTotal and mainsTotal for each audience. // get rank
    //       }
    //     });
    //   });
    // },

    // TOP PERFORMING FOR SCHOOL LEVEL
    async teacherSnapshotListener() {
      try {
        //console.log("inside extractClusterData fun >>>>........");
        const clustersRef = collection(
          db,
          "dashboards",
          this.userRoleId + "-vgos-teachers-dashboard",
          //  "123456-vgos-teachers-dashboard",
          "users"
        );

        // console.log("cluster_refg", clustersRef);
        // const clustersSnapshot = await getDocs(clustersRef);

        let unsubscribe = onSnapshot(clustersRef, (snapshot) => {
          this.schoolTeacher.splice(0);
          snapshot.forEach((clusterDoc) => {
            // console.log("abcdefg..>", clusterDoc.data());
            const topTeachersClusterData = {
              mainsTotal:
                clusterDoc.data().mainsTotal == null
                  ? ""
                  : clusterDoc.data().mainsTotal,
              name:
                clusterDoc.data().name == null ? "" : clusterDoc.data().name,
              userId: clusterDoc.data().userId ?? "",
              campaignId: clusterDoc.data().campaignId ?? "",
  
            };
            this.schoolTeacher.push(topTeachersClusterData);
            //console.log("DATAAA....",this.schoolClusterTeacher);
          });

          this.schoolTeacher.sort((p1, p2) =>
            p1.mainsTotal < p2.mainsTotal
              ? 1
              : p1.mainsTotal > p2.mainsTotal
              ? -1
              : 0
          );
          this.topTeacherInSchool = this.schoolTeacher;
          console.log("QAER..",this.topTeacherInCluster);
        });
        this.liveListenersToUnsubscribeMixin.push(unsubscribe);
      } catch (error) {
        // console.error("Error extracting cluster data:", error);
      }
    },

    // TOP PERFORMING FOR JOB SEEKERS AT SCHOOL LEVEL
    async jobSeekersSchoolSnapshotListener() {
      try {
        //console.log("inside extractClusterData fun >>>>........");
        const clustersRef = collection(
          db,
          "dashboards",
          this.userRoleId + "-jobseekers-dashboard",
          //  "123456-jobseekers-dashboard",
          "users"
        );
        //console.log("cluster refg", clustersRef);
        // const clustersSnapshot = await getDocs(clustersRef);

        let unsubscribe = onSnapshot(clustersRef, (snapshot) => {
          this.schoolClusterJobSeeker.splice(0);
          snapshot.forEach((clusterDoc) => {
            //console.log("abcdefg..>",clusterDoc.data())
            const topTeachersClusterData = {
              mainsTotal:
                clusterDoc.data().mainsTotal == null
                  ? ""
                  : clusterDoc.data().mainsTotal,
              name:
                clusterDoc.data().name == null ? "" : clusterDoc.data().name,
              level:
                clusterDoc.data().level == null
                  ? []
                  : clusterDoc.data().level,
              campaignId: clusterDoc.data().campaignId,
              userId: clusterDoc.data().userId
              //user.data().personalInfo.firstName
            };
            this.schoolJobSeeker.push(topTeachersClusterData);
            // console.log("DATAAA",this.schoolClusterJobSeeker);
          });

          let sortedProducts = this.schoolJobSeeker.sort((p1, p2) =>
            p1.mainsTotal < p2.mainsTotal
              ? 1
              : p1.mainsTotal > p2.mainsTotal
              ? -1
              : 0
          );
          this.topJobSeekerInSchool = this.schoolJobSeeker;
          console.log("QAER..",this.topJobSeekerInCluster);
        });
        this.liveListenersToUnsubscribeMixin.push(unsubscribe);
      } catch (error) {
        // console.error("Error extracting cluster data:", error);
  } 
    },

    // new code for top performing at cluster level(teachers)
    async teacherClusterSnapshotListener() {
      try {
        //console.log("inside extractClusterData fun >>>>........");
        // console.log("roleId", this.$store.state.role)
        const clustersRef = collection(
          db,
          "dashboards",
          // "SNMA86swHZpuQRYjaDK4-vgos-teachers-dashboard",
          this.userRoleId + "-vgos-teachers-dashboard",
          //  "123456-vgos-teachers-dashboard",
          "users"
        );
        // console.log("clustersRef", clustersRef)
        //console.log("cluster refg", clustersRef);
        // const clustersSnapshot = await getDocs(clustersRef);

        let unsubscribe = onSnapshot(clustersRef, (snapshot) => {
          this.schoolClusterTeacher.splice(0);

          snapshot.forEach((clusterDoc) => {
            console.log("abcdefg..>", clusterDoc.data());
            const topTeachersClusterData = {
              mainsTotal:
                clusterDoc.data().mainsTotal == null
                  ? 0
                  : clusterDoc.data().mainsTotal,
              name:
                clusterDoc.data().name == null ? "" : clusterDoc.data().name,
              campaignId: clusterDoc.data().campaignId,
              userId: clusterDoc.data().userId,
              //level: d.data().levels == null ? [] : d.data().levels,
              //user.data().personalInfo.firstName
            };
            this.schoolClusterTeacher.push(topTeachersClusterData);
          });
          console.log("DATAAA....", this.schoolClusterTeacher);
          this.topTeacherInCluster = this.schoolClusterTeacher.sort((p1, p2) =>
            p1.mainsTotal < p2.mainsTotal
              ? 1
              : p1.mainsTotal > p2.mainsTotal
              ? -1
              : 0
          );
          console.log("QAER..", this.topTeacherInCluster);
        });
        this.liveListenersToUnsubscribeMixin.push(unsubscribe);
      } catch (error) {
        // console.error("Error extracting cluster data:", error);
      }
    },

    // new code for top performing at cluster level(JB)
    async jobSeekersClusterSnapshotListener() {
      try {
        //console.log("inside extractClusterData fun >>>>........");
        const clustersRef = collection(
          db,
          "dashboards",
          this.userRoleId + "-jobseekers-dashboard",
          //  "123456-jobseekers-dashboard",
          "users"
        );
        //console.log("cluster refg", clustersRef);
        // const clustersSnapshot = await getDocs(clustersRef);

        let unsubscribe = onSnapshot(clustersRef, (snapshot) => {
          this.schoolClusterJobSeeker.splice(0);
          snapshot.forEach((clusterDoc) => {
            //console.log("abcdefg..>",clusterDoc.data())
            const topTeachersClusterData = {
              mainsTotal:
                clusterDoc.data().mainsTotal == null
                  ? ""
                  : clusterDoc.data().mainsTotal,
              name:
                clusterDoc.data().name == null ? "" : clusterDoc.data().name,
              level:
                clusterDoc.data().levels == null
                  ? []
                  : clusterDoc.data().levels,
              campaignId: clusterDoc.data().campaignId,
              userId: clusterDoc.data().userId,
              //user.data().personalInfo.firstName
            };
            this.schoolClusterJobSeeker.push(topTeachersClusterData);
            //console.log("DATAAA....",this.schoolClusterJobSeeker);
          });

          let sortedProducts = this.schoolClusterJobSeeker.sort((p1, p2) =>
            p1.mainsTotal < p2.mainsTotal
              ? 1
              : p1.mainsTotal > p2.mainsTotal
              ? -1
              : 0
          );
          this.topJobSeekerInCluster = this.schoolClusterJobSeeker;
          // console.log("QAER..",this.topJobSeekerInCluster);
        });
        this.liveListenersToUnsubscribeMixin.push(unsubscribe);
      } catch (error) {
        // console.error("Error extracting cluster data:", error);
      }
    },

    // TOTAL TEACHERS PARTICIPATED AT CLUSTER LEVEL :
    async setUpTotalTeacherParticipatedAtCluster() {
      const clusterName = this.$store.state.role.clusterName;
      //console.log("clusternameeeeee... >>", clusterName);

      const q = query(
        collection(db, "dashboards", "management-dashboard-001", "clusters"),
        where("name", "==", clusterName)
      );

      //console.log("query..", q);

      // Set up a listener for changes in the query
      let unsubscribe = onSnapshot(q, (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = doc.data(); // Get data from the document snapshot
          console.log("data printing", data);
          this.countTeacherCluster = data.totalTeachersInCluster;

          //console.log("TOTALTEACHERPARTICIAPTED.. >>", this.countTeacherCluster);
        });
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    // TOTAL USERS PARTICIPATED AT CLUSTER LEVEL :
    async setUpTotalUsersParticipatedAtCluster() {
      const clusterName = this.$store.state.role.clusterName;
      //console.log("clusternameeeeee... >>", clusterName);

      const q = query(
        collection(db, "dashboards", "management-dashboard-001", "clusters"),
        where("name", "==", clusterName)
      );

      //console.log("query..", q);

      // Set up a listener for changes in the query
      let unsubscribe = onSnapshot(q, (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = doc.data(); // Get data from the document snapshot
          console.log("data printing", data);
          this.countingJobSeekerCluster = data.totalUsersInCluster;

          console.log(
            "TOTALUSERSPARTICIAPTED.. >>",
            this.countingJobSeekerCluster
          );
        });
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    },

    compareDates(dateString1, dateString2, dateString3) {
      var validation = "";
      const currentDate = new Date(dateString1);
      const startDate = new Date(dateString2);
      const endDate = new Date(dateString3);

      if (currentDate >= startDate && currentDate <= endDate) {
        validation = "Live";
      } else if (currentDate < startDate) {
        validation = "Scheduled";
      } else {
        validation = "Expired";
      }
      return validation;
    },
    async campaignSnapshotListener() {
      var currentDate = new Date(Date.now()).toISOString();
      var todayDatevalue = this.formatDate(currentDate);
      const liveCollectionRef = collection(db, "campaigns");
      // console.log("live called");

      let unsubscribe = onSnapshot(liveCollectionRef, (snapshot) => {
        snapshot.docs.forEach((doc) => {
          const campaignData = doc.data();
          if (
            campaignData.campaignConfigration != null &&
            campaignData.isAudienceUpdated == true
          ) {
            if (campaignData.campaignConfigration != null && campaignData.isAudienceUpdated && campaignData.audienceType?.toLowerCase() === "teacher") {
              var valid = this.compareDates(
                todayDatevalue,
                campaignData.startDate,
                campaignData.mainsEndDate
              );
              if (valid == "Live") {
                this.liveCampaign.push(campaignData);
                this.liveCampaignlength = this.liveCampaign.length;
              } else if (valid == "Scheduled") {
                this.scheduledCampaign.push(campaignData);
                this.scheduledCampaignlength = this.scheduledCampaign.length;
              } else if (valid == "Expired") {
                this.expiredCampaign.push(campaignData);
                this.expiredCampaignlength = this.expiredCampaign.length;

              }
            }
          }
        });
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
      // console.log("Live", this.liveCampaign);
      // console.log("Schedule", this.scheduledCampaign);
      // console.log("expiredCampaign", this.expiredCampaign);
    },

    async totalSchoolsParticipated() {
      // const dashboardRef = doc(db, "dashboards", "management-dashboard-001");
      // // console.log("calledddddd");

      // onSnapshot(dashboardRef, (snapshot) => {
      //   //console.log("palviiiiiii", snapshot);
      //   const data = snapshot.data();
      //   const totalSchools = data.totalchools;
      //   //console.log("palvicountAjaaa",data);
      //   const totalTeacherCampaign = data.totalTeacherCampaign;
      //   const totalSchoolsCount = data.totalSchoolsCount;
      //   const totalTeachersParticipated = data.totalTeachersParticipated;
      //   const totalTeachersParticipatedCount =
      //     data.totalTeachersParticipatedCount;
      //   // this.totalTeachersParticipatedCount=totalTeachersParticipatedCount;
      //   // console.log("ghj", totalTeachersParticipated);

      //   this.donutArray.push(
      //     this.liveCampaignlength + this.scheduledCampaignlength + this.expiredCampaignlength,
      //     this.liveCampaignlength,
      //     this.expiredCampaignlength,
      //     totalSchoolsCount,
      //     totalTeachersParticipated,
      //     totalTeachersParticipatedCount
      //  );

      //   this.totalSchools = totalSchools;
      //   this.totalSchoolsCount = totalSchoolsCount;
      //   // console.log("palvicount", totalSchools);
      //   this.totalLiveTeacherCampaigns = totalTeacherCampaign;
      // });
      const todayDate = new Date().toISOString().split('T')[0];


        const campaignQuery = collection(db, 'campaigns');
        const teacherQuery = query(campaignQuery, where("audienceType","==","TEACHER"),where("isAudienceUpdated", "==", true));
        // const liveteacherQuery = query(teacherQuery, where("startDate","<=",todayDate),where("endDate",">=",todayDate));
        const expiredteacherQuery = query(teacherQuery, where("mainsEndDate","<",todayDate));
        const scheduledteacherQuery = query(teacherQuery, where("startDate",">",todayDate));
        const totalCampaigns = (await (getCountFromServer(teacherQuery))).data().count;
        const scheduledCampaign = (await (getCountFromServer(scheduledteacherQuery))).data().count;
        const expiredCampaign = (await (getCountFromServer(expiredteacherQuery))).data().count;
        const liveCampaign = totalCampaigns - expiredCampaign + scheduledCampaign;
        this.donutArray = [totalCampaigns, liveCampaign, expiredCampaign]
        const dashboardRef = doc(db, "dashboards", "management-dashboard-001");
        const snapshot = await getDoc(dashboardRef);
        const data = snapshot.data();
        console.log(data);
        this.totalSchools = data.totalSchools;
        this.totalSchoolsCount = data.totalSchoolsCount;

    },

    async setupSnapshotListenerFunnel() {
      const id = collection(
        db,
        "dashboards",
        "management-dashboard-001",
        "campaigns"
      );
      console.log("dashbaord id>>>", id);
      if (id === undefined) {
        console.log("isnide_iiif");
        this.chartData = this.emptyChartData;
        return;
        // console.log("isnide snap", this.chartData);
      }
      const data = await getDocs(id);
      if (data === undefined) {
        // console.log("isnide if");
        this.chartData = this.emptyChartData;
        return;
        // console.log("isnide snap", this.emptyChartData);
      }
      const document = data.docs[0];
      if (document === undefined) {
        // console.log("isnide if");
        this.chartData = this.emptyChartData;
        // console.log("isnide snap", this.emptyChartData);
      } else {
        const docRef = doc(id, data.docs[0].id);

        let unsubscribe = onSnapshot(docRef, (snapshot) => {
          let funnelData = snapshot.data();
          console.log("campaignStatus data received:", funnelData);
          if (
            funnelData.invited === undefined ||
            funnelData.screeningStarted === undefined ||
            funnelData.screeningPassed === undefined ||
            funnelData.screeningFailed === undefined ||
            funnelData.mainsStarted === undefined ||
            funnelData.mainsPassed === undefined ||
            funnelData.mainsFailed === undefined
          ) {
            // console.log("isnide if");
            this.chartData = this.emptyChartData;
            // console.log("inside if data", this.chartData);
          } else {
            this.chartData = funnelData;
            this.invited = funnelData.invited;
            this.screeningStarted = funnelData.screeningStarted;
            this.screeningPassed = funnelData.screeningPassed;
            this.mainsStarted = funnelData.mainsStarted;
            this.mainsPassed = funnelData.mainsPassed;
            this.screeningFailed = funnelData.screeningFailed;
            this.mainsFailed = funnelData.mainsFailed;

            this.apraisals = funnelData.mainsPassed;
            this.pip = funnelData.mainsFailed;
            this.tbd = funnelData.screeningFailed;

            // console.log(this.chartData);
          }
        });
        this.liveListenersToUnsubscribeMixin.push(unsubscribe);
      }
    },
    async setupSnapshotListenerJobSeekerFunnel() {
      const id = collection(
        db,
        "dashboards",
        "management-dashboard-001",
        "jobSeekerCampaign"
      );
      // console.log("inside_snapshot", id);

      if (id === undefined) {
        // console.log("inside_ifffff");
        this.jobSeekerChartData = this.emptyJobSeekerChartData;
        // console.log("this_jobSeekerChartData", this.jobSeekerChartData);
        return;
        // console.log("isnide snap", this.jobSeekerChartData);
      }
      // console.log("outside_iffff")

      const data = await getDocs(id);
      // console.log("data>>", data);
      if (data === undefined) {
        // console.log("inside___iiiiiif");
        this.jobSeekerChartData = this.emptyJobSeekerChartData;
        return;
        // console.log("isnide snap", this.jobSeekerChartData);
      }
      // console.log("outside_second_if")
      // console.log("get Docs", data.docs[0]);
      const document = data.docs[0];
      if (document === undefined) {
        // console.log("inside_third_if");
        this.jobSeekerChartData = this.emptyJobSeekerChartData;
        // console.log("isnide snap", this.jobSeekerChartData);
      } else {
        // console.log("outside_third_if");

        const docRef = doc(id, data.docs[0].id);

        let unsubscribe = onSnapshot(docRef, (snapshot) => {
          let funnelData = snapshot.data();

          if (
            funnelData.jobSeekerInvited === undefined ||
            funnelData.jobSeekerScreeningStarted === undefined ||
            funnelData.jobSeekerScreeningPassed === undefined ||
            funnelData.jobSeekerScreeningFailed === undefined ||
            funnelData.jobSeekerMainsStarted === undefined ||
            funnelData.jobSeekerMainsPassed === undefined ||
            funnelData.jobSeekerMainsFailed === undefined
          ) {
            // console.log("isnide if");
            this.jobSeekerChartData = this.emptyJobSeekerChartData;
            // console.log("isnide snap", this.jobSeekerChartData);
          } else {
            // console.log("isnide else:", funnelData);
            this.jobSeekerChartData = funnelData;

            // console.log("inisde snap job", this.jobSeekerChartData);
            this.recommended = funnelData.jobSeekerMainsPassed;
            this.jobSeekerRejected = funnelData.jobSeekerMainsFailed;
            this.jobSeekerTBD = funnelData.jobSeekerScreeningFailed;
          }
        });
        this.liveListenersToUnsubscribeMixin.push(unsubscribe);
      }
    },

    calculatePercentage(value, total) {
      if (total === 0) {
        // console.log("Error: Total cannot be zero.");
        return 0;
      }
      const percentage = (value / total) * 100;
      if (isNaN(percentage)) {
        // console.log("Error: Invalid input. Please provide valid numbers.");
        return 0;
      }
      const roundedPercentage = Math.round(percentage);
      // console.log(roundedPercentage);
      return roundedPercentage;
    },

    async setupSnapshotListenerSchoolHrFunnel() {
      const id = collection(
        db,
        "dashboards",
        "management-dashboard-001",
        "schools"
      );
      // console.log("inside snapshot", id);
      if (!id) {
        // console.log("isnide if dashboard");
        this.schoolChartData = this.emptySchoolChartData;
        return;
        // console.log("isnide snap", this.schoolChartData);
      }

      const q = query(id, where("name", "==", this.roleSchool));
      // const data = await getDocs(id);
      // console.log("data",data)
      // var data;
      // console.log("query??", q);
      if (!q.exists) {
        // console.log("isnide if query");
        this.schoolChartData = this.emptySchoolChartData;
        return;
        // console.log("isnide snap", this.schoolChartData);
      }
      // console.log("get Docs schools?>>", q);

      let unsubscribe = onSnapshot(q, (snapshot) => {
        snapshot.forEach((doc) => {
          // console.log("data teachers###", doc.data());
          if (
            doc.data().totalInvited === undefined ||
            doc.data().totalScreeningStarted === undefined ||
            doc.data().totalScreeningPassed === undefined ||
            doc.data().totalScreeningFailed === undefined ||
            doc.data().totalMainsFailed === undefined ||
            doc.data().totalMainsPassed === undefined ||
            doc.data().totalMainsStarted === undefined
          ) {
            // console.log("inside snapshot teacher>>>");
            this.schoolChartData = this.emptySchoolChartData;
            // console.log("isnide snap", this.schoolChartData);
          } else {
            this.schoolChartData = doc.data();
          }
        });
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },
    async setupSnapshotListenerJobSeekersSchoolHrFunnel() {
      const id = doc(
        db,
        "dashboards",
        this.userRoleId + "-jobseekers-dashboard",
        "results",
        "campaignresults"
      );

      let unsubscribe = onSnapshot(id, (snapshot) => {
        const data = snapshot.data();

        if (!data) {
          this.schoolJobSeekerChartData = this.emptySchoolJobSeekerChartData;
          return;
        }

        if (
          data.invited === undefined ||
          data.screeningStarted === undefined ||
          data.screeningPassed === undefined ||
          data.screeningFailed === undefined ||
          data.mainsFailed === undefined ||
          data.mainsPassed === undefined ||
          data.mainsStarted === undefined ||
          data.demoSubmitted === undefined ||
          data.interviewSubmitted === undefined
        ) {
          this.schoolJobSeekerChartData = this.emptySchoolJobSeekerChartData;
        } else {
          this.schoolJobSeekerChartData = data;
        }
      }, (error) => {
        console.error("Error fetching snapshot:", error);
        this.schoolJobSeekerChartData = this.emptySchoolJobSeekerChartData;
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async setupSnapshotListenerTeacherClusterFunnel() {
      const id = collection(
        db,
        "dashboards",
        "management-dashboard-001",
        "clusters"
      );
      console.log("chk1");
      // console.log("kdjkbcsjbjc", id);
      if (!id) {
        console.log("chk2");
        // console.log("isnide if dashboard");
        this.clusterTeacherChartData = this.emptyClusterTeacherChartData;
        return;
        // console.log("isnide snap", this.schoolChartData);
      }

      // const idData=await getDocs(id);
      // idData.forEach((doc)=>{
      //   console.log("idData...", doc.id, doc.data())
      // })

      // console.log("idData", idData);

      const q = query(id, where("name", "==", this.roleCluster));
      // console.log("this_cluster", q.exists);

      // console.log("this.roleCluster", this.roleCluster)
      if (!q.exists) {
        console.log("chk3");
        //console.log("isnide if query");
        this.clusterTeacherChartData = this.emptyClusterTeacherChartData;
        return;
        // console.log("isnide snap", this.schoolJobSeekerChartData);
      }

      const data = await getDocs(q);
      console.log("abcdef", data);

      // console.log("data current >>", data.docs[0].id);
      const schoolRef = collection(
        db,
        "dashboards",
        "management-dashboard-001",
        "clusters",
        data.docs[0].id,
        "schools"
      );

      // console.log("schoolRef", schoolRef)
      if (!(await getDocs(schoolRef))) {
        // console.log("isnide if Adil");
        this.clusterTeacherChartData = this.emptyClusterTeacherChartData;
        return;
      }
      console.log("outSidegetdocs");
      let unsubscribe = onSnapshot(schoolRef, (snapshot) => {
        this.clusterTeacherChartData = {
          totalInvited: 0,
          totalScreeningStarted: 0,
          totalScreeningPassed: 0,
          totalScreeningFailed: 0,
          totalMainsStarted: 0,
          totalMainsPassed: 0,
          totalMainsFailed: 0,
        };
        snapshot.forEach((doc) => {
          if (
            doc.data().totalInvited === undefined ||
            doc.data().totalScreeningStarted === undefined ||
            doc.data().totalScreeningPassed === undefined ||
            doc.data().totalScreeningFailed === undefined ||
            doc.data().totalMainsFailed === undefined ||
            doc.data().totalMainsPassed === undefined ||
            doc.data().totalMainsStarted === undefined
          ) {
            this.clusterTeacherChartData = this.emptyClusterTeacherChartData;
            // console.log("bskdbcj", this.clusterTeacherChartData);
          } else {
            console.log("ak###", doc.data());
            this.clusterTeacherChartData.totalInvited +=
              doc.data().totalInvited;
            this.clusterTeacherChartData.totalScreeningStarted +=
              doc.data().totalScreeningStarted;
            this.clusterTeacherChartData.totalScreeningPassed +=
              doc.data().totalScreeningPassed;
            this.clusterTeacherChartData.totalScreeningFailed +=
              doc.data().totalScreeningFailed;
            this.clusterTeacherChartData.totalMainsStarted +=
              doc.data().totalMainsStarted;
            this.clusterTeacherChartData.totalMainsPassed +=
              doc.data().totalMainsPassed;
            this.clusterTeacherChartData.totalMainsFailed +=
              doc.data().totalMainsFailed;
            console.log("bhcjsbdc", this.clusterTeacherChartData);
          }
        });
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },
    async setupSnapshotListenerJobSeekersClusterFunnel() {
      const roleId = this.userRoleId;
      const dashboardRef = doc(db, "dashboards", `${roleId}-jobseekers-dashboard`);

      if (!dashboardRef) {
          this.clusterJobSeekersChartData = this.emptyClusterJobSeekersChartData;
          return;
      }

      const resultsRef = collection(dashboardRef, "results");

      if (!resultsRef) {
          this.clusterJobSeekersChartData = this.emptyClusterJobSeekersChartData;
          return;
      }

      const campaignDocRef = doc(resultsRef, "campaignresults");

      if (!campaignDocRef) {
          this.clusterJobSeekersChartData = this.emptyClusterJobSeekersChartData;
          return;
      }

      let unsubscribe = onSnapshot(campaignDocRef, (docSnapshot) => {
          if (!docSnapshot.exists()) {
              this.clusterJobSeekersChartData = this.emptyClusterJobSeekersChartData;
              return;
          }

          const data = docSnapshot.data();

          if (
              data.invited === undefined ||
              data.screeningStarted === undefined ||
              data.screeningPassed === undefined ||
              data.screeningFailed === undefined ||
              data.mainsStarted === undefined ||
              data.mainsPassed === undefined ||
              data.mainsFailed === undefined ||
              data.demoSubmitted === undefined ||
              data.interviewSubmitted === undefined
          ) {
              this.clusterJobSeekersChartData = this.emptyClusterJobSeekersChartData;
          } else {
              this.clusterJobSeekersChartData = {
                  totalJobSeekersInvited: data.invited,
                  totalJobSeekersScreeningStarted: data.screeningStarted,
                  totalJobSeekersScreeningPassed: data.screeningPassed,
                  totalJobSeekersScreeningFailed: data.screeningFailed,
                  totalJobSeekersMainsStarted: data.mainsStarted,
                  totalJobSeekersMainsPassed: data.mainsPassed,
                  totalJobSeekersMainsFailed: data.mainsFailed,
                  totalJobSeekersDemoSubmitted: data.demoSubmitted,
                  totalJobSeekersInterviewSubmitted: data.interviewSubmitted,
              };
          }
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
  },

    formatInputDate(inputDate) {
      const date = new Date(inputDate);
      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();

      return `${day} ${month} ${year}`;
    },

    async teacherMainsBookingAdminSnapshot() {
      console.log("this.userRoleId--->",this.userRoleId);
      const campaignRef = collection(
        db,
        "dashboards",
        this.userRoleId + "-vgos-teachers-dashboard",
        // "123456-vgos-teachers-dashboard",
        "mainsbookings"
      );
      let unsubscribe = onSnapshot(campaignRef, (snapshot) => {
        this.mainsBookingTeacherSchool.clear();
        snapshot.docs.forEach(async (doc) => {
          const clusterData = doc.data();
          const clusterCountValue = clusterData.userCount;
          // const mainsBookingTeacher = [doc.id, clusterCountValue];
          // console.log("pooh...>>",mainsBookingTeacher);
          this.mainsBookingTeacherSchool.set(doc.id, clusterCountValue);
          // this.mainsBookingTeacherSchool.push(mainsBookingTeacher);
        });
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async jobSeekerMainsBookingAdminSnapshot() {
      const campaignRef = collection(
        db,
        "dashboards",
        this.userRoleId + "-jobseekers-dashboard",
        // "123456-jobseekers-dashboard",
        "mainsbookings"
      );
      let unsubscribe = onSnapshot(campaignRef, (snapshot) => {
        this.mainsBookingJobSeekerSchool.clear();
        snapshot.docs.forEach(async (doc) => {
          const clusterData = doc.data();
          const clusterCountValue = clusterData.userCount;
          // const mainsBookingJobSeeker = [doc.id, clusterCountValue];
          // console.log("pooh...>>",mainsBookingJobSeeker);
          this.mainsBookingJobSeekerSchool.set(doc.id, clusterCountValue);
          // this.mainsBookingJobSeekerSchool.push(mainsBookingJobSeeker);
        });
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    // async jobSeekerMainsBookingAdminSnapshot() {
    //   const campaignRef = collection(db, "users"); // const schoolMarks = {}
    //   //console.log("abc...>>>");
    //   onSnapshot(campaignRef, (snapshot) => {
    //     this.mainsBookingJobSeekerSchool.clear();
    //     snapshot.docs.forEach(async (doc) => {
    //       // if teacher, run this
    //       const userData = doc.data();
    //       //console.log("userData....>>>>>",userData);
    //       let user = 0;
    //       if (
    //         userData.userType.toLowerCase() === "job seeker" &&
    //         userData.mainsSlotDetails !== undefined &&
    //         userData.schoolName == this.$store.state.role.schools
    //       ) {
    //         try {
    //           const date = userData.mainsSlotDetails.date;

    //           const formattedDate = this.formatInputDate(date);
    //           //console.log("RashidPerfect..>>>",formattedDate);
    //           if (!(formattedDate in this.mainsBookingJobSeekerSchool)) {
    //             this.mainsBookingJobSeekerSchool.set(formattedDate, 1);
    //           } else {
    //             const temp =
    //               this.mainsBookingJobSeekerSchool.get(formattedDate);
    //             this.mainsBookingJobSeekerSchool.set(formattedDate, temp + 1);
    //           }
    //         } catch (error) {
    //           console.error("Error fetching audience collection:", error);
    //         }
    //       }
    //     });
    //   });
    // },

    async schoolLevelLiveCampaignSnapshot() {
      const currentDate = new Date();
      //console.log("hii",currentDate);
      const campaignRef = collection(db, "campaigns");

      let unsubscribe = onSnapshot(campaignRef, (snapshot) => {
        snapshot.docs.forEach(async (doc) => {
          const newDateForm = new Date(
            doc.data().mainsEndDate + "T" + doc.data().mainsEndTime + "Z"
          );
          const newDate = new Date(
            doc.data().startDate + "T" + doc.data().campaignStartTime + "Z"
          );
          // console.log(newDateForm);
          // console.log(newDate);
          if (
            doc.data().audienceType?.toLowerCase() === "teacher" &&
            doc.data().schools.includes(this.$store.state.role.schools)
          ) {
            if (newDateForm < currentDate) {
              this.expiredCampaignCount += 1;
              // console.log("this is expired", this.expiredCampaignCount);
            } else if (doc.data().startDate && currentDate < newDate) {
              this.upcomingCampaignCount += 1;
              // console.log("this is upcoming", this.upcomingCampaignCount);
            } else {
              this.liveCampaignCount += 1;
            }
          }
        });
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    async schoolLevelLiveCampaignJobSeekersSnapshot() {
      const currentDate = new Date();
      //console.log("hii",currentDate);
      const campaignRef = collection(db, "campaigns");

      let unsubscribe = onSnapshot(campaignRef, (snapshot) => {
        snapshot.docs.forEach(async (doc) => {
          const newDateForm = new Date(
            doc.data().mainsEndDate + "T" + doc.data().mainsEndTime + "Z"
          );
          const newDate = new Date(
            doc.data().startDate + "T" + doc.data().campaignStartTime + "Z"
          );
          // console.log(newDateForm);
          // console.log(newDate);
          if (
            doc.data().audienceType?.toLowerCase() === "job_seeker" &&
            doc.data().schools.includes(this.$store.state.role.schools)
          ) {
            if (newDateForm < currentDate) {
              this.expiredCampaignCountJB += 1;
              // console.log("this is expired", this.expiredCampaignCount);
            } else if (doc.data().startDate && currentDate < newDate) {
              this.upcomingCampaignCountJB += 1;
              // console.log("this is upcoming", this.upcomingCampaignCount);
            } else {
              this.liveCampaignCountJB += 1;
            }
          }
        });
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },

    getClusterOrSchool() {
      this.roleCluster = this.$store.state.role.clusterName;
      this.roleSchool = this.$store.state.role.schools;

      // if (this.roleSchool == undefined) {
      //   AuthService.logout();
      //   this.$router.push("/login");
      // }
      // if (this.roleCluster != "All Clusters") {
      //   this.campaignData.clusters = [this.roleCluster];
      //   this.getClusterSchool();
      // }
      // if (this.roleSchool != "All") {
      //   this.campaignData.schools = [this.roleSchool];
      // }
    },
    // For Super Admin - Job seeker campaign snapshot
    async adminLevelJobSeekerCampaignSnapshot() {
      try {
        const todayDate = new Date().toISOString().split('T')[0];


        const campaignQuery = collection(db, 'campaigns');
        const jobQuery = query(campaignQuery, where("audienceType","in",["JOB SEEKER","JOB_SEEKER","JOB-SEEKER"]),where("isAudienceUpdated", "==", true));
        // const liveJobQuery = query(jobQuery, where("startDate","<=",todayDate),where("endDate",">=",todayDate));
        const expiredJobQuery = query(jobQuery, where("mainsEndDate","<",todayDate));
        const scheduledJobQuery = query(jobQuery, where("startDate",">",todayDate));
        const totalCampaigns = (await (getCountFromServer(jobQuery))).data().count;
        const scheduledCampaign = (await (getCountFromServer(scheduledJobQuery))).data().count;
        const expiredCampaign = (await (getCountFromServer(expiredJobQuery))).data().count;
        const liveCampaign = totalCampaigns - expiredCampaign + scheduledCampaign;
        this.donutArrayAdminJobSeeker = [totalCampaigns, liveCampaign, expiredCampaign]

        // onSnapshot(campaignQuery, async (snapshot) => {
        //   if (snapshot.empty) {
        //     return;
        //   }

        //   let liveCampaign = [];
        //   let scheduledCampaign = [];
        //   let expiredCampaign = [];
        //   let totalCampaigns = 0;

        //   const campaigns = snapshot.docs.map((doc) => doc.data())

        //   campaigns.forEach(campaignWithAudience => {
        //     if (campaignWithAudience) {
        //       totalCampaigns++;
        //       const valid = this.compareDates(todayDatevalue, campaignWithAudience.startDate, campaignWithAudience.mainsEndDate);
        //       if (valid === 'Live') {
        //         liveCampaign.push(campaignWithAudience);
        //       } else if (valid === 'Scheduled') {
        //         scheduledCampaign.push(campaignWithAudience);
        //       } else if (valid === 'Expired') {
        //         expiredCampaign.push(campaignWithAudience);
        //       }
        //     }
        //   });

        //   // Update donut array counts
        //   this.donutArrayAdminJobSeeker = [totalCampaigns, liveCampaign.length, expiredCampaign.length ]
        // }, (error) => {
        //   console.error("Error in onSnapshot:", error);
        // });


      } catch (error) {
        console.error("Error in adminLevelJobSeekerCampaignSnapshot:", error);
      }
    },

    async recommendedJobseekerCountListener() {
      const campaignRef = collection(db, "campaigns");
      const audienceTypes = ['JOB_SEEKER', 'JOBSEEKER', 'JOB SEEKER', 'JOB-SEEKER'];
      const clusterName = this.$store.state.role.clusterName;
      console.log("clusterName==>", clusterName);
      console.log("audienceTypes==>", audienceTypes);

      let jobSeekerQuery = query(
        campaignRef,
        where('audienceType', 'in', audienceTypes)
      );

      if (clusterName !== "All Clusters") {
        jobSeekerQuery = query(jobSeekerQuery, where('clusters', 'array-contains-any', [clusterName]));
      }

      let unsubscribe = onSnapshot(jobSeekerQuery, async (snapshot) => {
        console.log("Snapshot received.");
        this.recommendedJobseekerCount = 0; // reset count on every snapshot
        const processedJobSeekers = new Set(); // keep track of processed job seekers

        for (const doc of snapshot.docs) {
          try {
            const jobSeekerRef = collection(campaignRef, doc.id, "audience");
            const jobSeekDocs = await getDocs(jobSeekerRef);

            for (const d of jobSeekDocs.docs) {
              const jobSeekerData = d.data();
              const schoolName = this.$store.state.role.schools;
              const jobSeekerSchoolName = jobSeekerData.teachingInterests?.schools ?? [];
              const jobseekerCluster = Array.isArray(jobSeekerData.cluster) ? jobSeekerData.cluster[0] : jobSeekerData.cluster ?? "" 
              const school = Array.isArray(jobSeekerSchoolName)
                ? jobSeekerSchoolName[0] ?? ""
                : jobSeekerSchoolName;

              if (
                (clusterName === "All Clusters" && schoolName === "All") ||
                (clusterName !== "All Clusters" && schoolName === "All" && jobseekerCluster === clusterName) ||
                (clusterName !== "All Clusters" && ((typeof jobSeekerSchoolName === 'string' && school === schoolName) || (Array.isArray(jobSeekerSchoolName) && jobSeekerSchoolName.includes(schoolName))))
              ) {
                // Only process each job seeker once
                if (!processedJobSeekers.has(d.id)) {
                  processedJobSeekers.add(d.id);

                  if (
                    jobSeekerData?.campaignStatus?.length === 5 &&
                    jobSeekerData.campaignStatus[2].status === "SCREENING PASSED" &&
                    jobSeekerData.campaignStatus[4].status === "MAINS PASSED" &&
                    jobSeekerData?.coreSkillsSubject?.length > 0 &&
                    jobSeekerData?.interViewFeedback?.length > 0
                  ) {
                    let netScoreMains = 0;
                    let netScoreInterview = 0;

                    for (const dt of jobSeekerData.coreSkillsSubject) {
                      if (dt.league !== "Not Eligible") {
                        netScoreMains += parseFloat(dt.finalNetScore) || 0;
                      }
                    }

                    for (const interview of jobSeekerData.interViewFeedback) {
                      netScoreInterview += parseFloat(interview.avgScore) || 0;
                    }

                    const avgMainsScore = netScoreMains / jobSeekerData.coreSkillsSubject.length;
                    const avgInterviewScore = netScoreInterview / jobSeekerData.interViewFeedback.length;
                    const netFinalRecommendationScore = (avgMainsScore + avgInterviewScore) / 2;

                    if (netFinalRecommendationScore >= 0) {
                      this.recommendedJobseekerCount += 1;
                    }
                  }
                }
              }
            }
          } catch (error) {
            console.error("Error fetching audience collection:", error);
          }
        }
        console.log("Final recommendedJobseekerCount:", this.recommendedJobseekerCount);
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },
    async adminDashboardListeners() {
      await Promise.all([
      this.newJobSeekerFunnelChartDataListener(),
      this.newTeacherFunnelChartDataListener(),
      this.recommendedJobseekerCountListener(),
      ]);

      await Promise.all([
      this.setupAdminJobSeekerSnapshot(),
      this.adminLevelJobSeekerCampaignSnapshot(),
      this.totalSchoolsParticipated(),
      this.schoolSnapshotListener(),
      this.extractClusterData(),
      this.jobSeekerAdminSnapshot(),
      ]);         
    },
    async clusterDashboardListerner() {
      await Promise.all([
        this.setupSnapshotListenerJobSeekersClusterFunnel(),
        this.newTeacherFunnelChartDataListener(),
        this.recommendedJobseekerCountListener(),
      ]);
      await Promise.all([
      this.jobSeekersClusterSnapshotListener(),
      this.setupclusterJobSeekerSnapshot(),
      this.teacherClusterSnapshotListener(),
      this.setupclusterSnapshotListener(),
      this.setupclusterTeacherCountSnapshot(),
      ])
    },

    async schoolDashboardListener() {
      await Promise.all([
        this.setupSnapshotListenerJobSeekersSchoolHrFunnel(),
        this.recommendedJobseekerCountListener(),
        this.newTeacherFunnelChartDataListener(),
      ])

      await Promise.all([
      this.jobSeekersSchoolSnapshotListener(),
      this.setupschoolSnapshotListener(),
      this.totalSchoolsParticipated(),
      this.teacherSnapshotListener(),
      ])
      
    }
  },
  async created() {
    const isCampaignUserPath = this.$store.state.firstFullPath;
    if(!this.$store.state.role.dashboard || !this.checkMultipeActiveRoles(['vgos', 'mesta', 'jobseeker'])) {
      this.$store.state.role.landingUrl !== '/' ? this.$router.replace(this.$store.state.role.landingUrl) : isCampaignUserPath.includes('campaignUser') ? this.$router.replace(isCampaignUserPath) : "";

      return;
    }
    // if (isCampaignUserPath.includes('campaignUser')) {
    //   this.$router.replace(isCampaignUserPath);
    // }
    this.getClusterOrSchool();
    console.log('vuex user role id', this.userRoleId)
    if(this.roleCluster === 'All Clusters' && this.roleSchool === 'All') {
      this.adminDashboardListeners();
    }
    else if(this.roleCluster !== "All Clusters" && this.roleSchool === "All") {
      this.clusterDashboardListerner()
    }
    else if(this.roleCluster !== "All Clusters" && this.roleSchool !== "All") {
      this.schoolDashboardListener()
    }
    // this.setUpTotalUsersParticipatedAtCluster();
    // this.setUpTotalTeacherParticipatedAtCluster();
    // this.jobSeekersSchoolSnapshotListener();
    // this.setupclusterTeacherCountSnapshot();
    // this.schoolLevelLiveCampaignJobSeekersSnapshot();
    // this.schoolLevelLiveCampaignSnapshot();
    // this.jobSeekerMainsBookingAdminSnapshot();
    // this.teacherMainsBookingAdminSnapshot();
    // this.extractClusterData();
    // this.schoolCountSchoolListener();
    // this.schoolCountClusterListener();
    // this.teacherClusterSnapshotListener();
    // this.jobSeekerCountListener();
    // this.schoolCountListener();
    // this.setupclusterJobSeekerSnapshot();
    // this.setupAdminJobSeekerSnapshot();
    // this.jobSeekerCountClusterListener();
    // this.jobSeekerCountSchoolListener();
    // this.jobSeekerAdminSnapshot();
    // this.setupschoolSnapshotListener();
    // this.campaignSnapshotListener();
    // this.setupclusterSnapshotListener();
    // this.setupSnapshotListenerFunnel();
    // this.setupSnapshotListenerJobSeekerFunnel();
    // this.schoolSnapshotListener();
    // this.totalSchoolsParticipated();
    // this.teacherSnapshotListener();
    // this.setupSnapshotListenerSchoolHrFunnel();
    // this.setupSnapshotListenerJobSeekersSchoolHrFunnel();
    // this.jobSeekersClusterSnapshotListener();
    // this.setupSnapshotListenerTeacherClusterFunnel();
    // this.setupSnapshotListenerTeacherClusterFunnel();
    // this.setupSnapshotListenerJobSeekersClusterFunnel();
    // this.newTeacherFunnelChartDataListener();
    // this.newJobSeekerFunnelChartDataListener();
    // this.adminLevelJobSeekerCampaignSnapshot();
    // this.recommendedJobseekerCountListener();
  },
  watch: {
    selectedItem(newValue, oldValue) {
      console.log("changing ");
      console.log("teachers", this.teachers);
      this.topSchools = this.schools.slice(0, this.selectedItem);
      console.log("teachers", this.topSchools);
    },
    isFullScreen(newValue) {
      // Update the body background color when full-screen mode is active
      if (newValue) {
        document.body.style.backgroundColor = this.fullscreenBackgroundColor;
      } else {
        // Revert to the default background color when exiting full-screen mode
        document.body.style.backgroundColor = "";
      }
    },
  },

  mounted() {
    this.activeIndex = this.$store.getters.currentCraouselIndex;
    if (this.$store.state.role.createdOn == undefined) {
      this.logout();
    }
    this.roleName = this.$store.state.role.roleName || "";
    console.log(
      "test !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!",
      this.$store.state.role.roleName
    );
  },
  beforeDestroy(){
    this.$store.dispatch('setCurrentCraouselIndex', this.activeIndex)
  },
};
</script>

<style scoped>
.heading {
  display: flex;
  align-content: center;
  justify-content: space-between;
  margin-left:0px;
}

/* .custom-table th.v-data-table__thead > tr > th {
  background-color: #f0f0f0;
  
} */

.dimension {
  margin-top: 16px !important;
}

.chart-row {
  padding-left: 48px !important;
  height: 43.5vh !important;
  width: 100%;
}

.sec-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 210px;
  background-color: white;
  border-radius: 8px;
  height: 100%;
}

.dashboard-card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  color: #212121;
  border: 1px solid #A3A3A3;
  padding: 6px;
  gap: 6px;
}

.dashboard-card-top-text, .dashboard-card-teachers-count {
  line-height: 16px;
}

.dashboard-card-row {
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.sec-col-school {
  background-color: white;
  border-radius: 8px;
  /* margin-top: 15px; */
  height: 38vh;
}

.school-box {
  height: 31px;
  /* padding: 8px; */
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.26);
  background-color: white;
  margin-left: 35px;
  width: calc(100% - 40px);
  /* justify: space-between; */
}

.custom-data-table[data-v-9ea40744] {
  background-color: white;
}

thead .v-data-table-header {
  background: white !important;
}

.margin-betwen-col {
  margin: 8px 8px 8px 8px;
}

/* .margin-betwen-col-2 {
  margin: 2px 2px 2px 2px;
} */

.col3 {
  height: 100%;
  /* padding-right: 0; */
}

.col3-card {
  width: 100%;
  height: 11vh;
  margin-bottom: 2.263vh;
}

.dashboard > table > thead > tr {
  background-color: white !important;
}

.funnel-contianer {
  display: flex;
  height: 33.3vh;
}

.tbl > .t-head > .t-row > .head {
  background-color: white;
}

.t-row {
  background-color: white !important;
}

.tbl2 > .t-head > .t-row > .head {
  background-color: white;
}

.tbl {
  height: 23vh;
  width: 100%;
  text-align: left;
  font-size: 14px;
}

.tbl3 {
  height: 25.7vh;
  width: 100%;
  text-align: left;
}

.scroll-table {
  height: 170px;
  overflow-y: scroll;
}

.tbl2 {
  height: 33vh;
  width: 100%;
  text-align: left;
}

.tblClusterJob {
  height: 30vh;
  width: 100%;
  text-align: left;
}

.t-body {
  height: auto;
}

.tbl2 > .t-body > .t-row {
  background-color: white;
}

.tbl > .t-body > .t-row {
  background-color: white;
}

.head {
  text-align: center;
}

.tbl > .t-body > .t-row > .t-data {
  text-align: center;
}

.tbl > tr:nth-child(even) {
  background-color: white !important;
}

.tbl2 > tr:nth-child(even) {
  background-color: white !important;
}

.total-count {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  width: 100%;
  height: 31px;
  background-color: #4d695b;
  border-radius: 4px;
  padding: 0 8px 0 8px;
}

.chart-icon {
  position: absolute;
  bottom: 40px;
  z-index: 1000;
  align-self: center;
}

.red-text {
  color: red;
}

.green-text {
  color: green;
}

.carousel-buttons {
  display: flex;
  justify-content: center;
  margin-top: -30px;
  /* Adjust this value as desired */
}

.carousel-button {
  margin: 0 2px;
  height: auto;
  /* min-width: 15px; */
  width: 28px;
  height: 16px;
  max-width: 40px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  font-size: 12px;
  /* Adjust font size as needed */
}

.carousel-button.active {
  background-color: brown;
  color: white;
}

.chip-button-label {
  line-height: 22px;
  padding: 0 8px;
}

.custom-carousel .v-carousel__controls {
  display: none !important;
}


.decrease-top-spacing-teacher, .decrease-top-spacing-jobSeeker {
  padding: 0 10px;
  /* Adjust the value as desired */
}


.decrease-top-spacing-school {
  margin-top: -20px;
  margin-bottom: -8px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.circle-outline {
  display: flex;
  align-items: center;
  width: 100px;
  height: 10px;
  border-radius: 15px;
  padding: 5px;
  text-align: center;
  color: #000;
}

.circle-radius {
  border-radius: 10%;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.circle-outline {
  display: flex;
  align-items: center;
  width: 100px;
  height: 8px;
  border-radius: 15px;
  padding: 5px;
  text-align: center;
  color: #000;
}

.circle-radius {
  border-radius: 10%;
}

.flag-spacing {
  margin-left: 10px;
}

.flag-icon {
  width: 25px;
  height: 25px;
  margin-right: 0;
  padding-top: 5px;
  padding-right: 5px;
}

.no-space {
  margin-left: 0;
}

.fullScreenSize {
  position: fixed;
  left: 30px;
  right: 30px;
  top: 100px;
  /* left: -100px; */
}

.bookingBox {
  height: 100%;
  overflow: hidden;
}

.bookMargin {
  margin-bottom: -8px !important;
}

.home-view-container {
  padding: 0 16px 0 32px;
  th {
    font-size: 14px;
    letter-spacing: 0;
  }
}

.v-application .blue--text {
  font-family: "GraphikMedium", sans-serif !important;
  font-weight: 500;
  padding: 0;
}

.theme--light.v-btn:focus::before, .theme--light.v-btn:hover::before {
  opacity: 0;
}

.v-application .text-h6 {
  padding: 0;
}

.left-header, 

.coming-soon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa; /* Adjust as needed */
  border: 1px solid #ddd; /* Adjust as needed */
  border-radius: 8px; /* Adjust as needed */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow */
  transition: transform 0.2s, box-shadow 0.2s; /* Adds transition for hover effect */
}

.coming-soon-text {
  background-color: #000;
  font-weight: bold; /* Bold text */
  text-align: center; /* Center the text */
  padding: 0 10px; /* Add some padding */
  -webkit-background-clip: text; /* Clip background to text */
  background-clip: text;
  -webkit-text-fill-color: transparent; /* Make text transparent to show gradient */
}

.home-view-carousel {
  overflow: auto !important;
}


</style>